import React, { createContext, useState } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [expiryTime, setExpiryTime] = useState(null);
    const [storyLine, setStoryLine] = useState(null);
    const [coockies, setCoockies] = useState(false);

    const login = (userData, expiryTime) => {
        setUser(userData);
        setExpiryTime(expiryTime);
    };

    const logout = () => {
        setUser(null);  // Benutzer ausloggen
        setExpiryTime(null);
        setStoryLine(null);
        localStorage.removeItem('token');
        localStorage.removeItem('userId');
    };

    const currStoryLine =(storyLineName) => {
        setStoryLine(storyLineName);
    }

    const allowCoockies =() => {
        setCoockies(true);
    }

    return (
        <AuthContext.Provider value={{ user, storyLine, coockies, expiryTime, login, logout, currStoryLine, allowCoockies }}>
            {children}
        </AuthContext.Provider>
    );
};